type CanvasContext = {
    canvas: HTMLCanvasElement;
    ctx: CanvasRenderingContext2D;
    width: number;
    height: number;
};

export function setupCanvas(canvas: HTMLCanvasElement): CanvasContext | null {
    const rect = canvas.getBoundingClientRect();
    const width = Math.max(1, Math.floor(rect.width));
    const height = Math.max(1, Math.floor(rect.height));
    const dpr = window.devicePixelRatio || 1;

    canvas.width = Math.floor(width * dpr);
    canvas.height = Math.floor(height * dpr);

    const ctx = canvas.getContext('2d');
    if (!ctx) return null;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

    return { canvas, ctx, width, height };
}

export function clearCanvas(ctx: CanvasRenderingContext2D, width: number, height: number): void {
    ctx.clearRect(0, 0, width, height);
}

export function normalizeRange(values: number[]): { min: number; max: number } {
    if (values.length === 0) return { min: 0, max: 1 };
    let min = Number.POSITIVE_INFINITY;
    let max = Number.NEGATIVE_INFINITY;
    for (const v of values) {
        min = Math.min(min, v);
        max = Math.max(max, v);
    }
    if (min === max) {
        const pad = Math.max(1, Math.abs(min) * 0.02);
        return { min: min - pad, max: max + pad };
    }
    return { min, max };
}

export function drawGrid(
    ctx: CanvasRenderingContext2D,
    width: number,
    height: number,
    xSteps: number,
    ySteps: number,
    color: string,
): void {
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = 1;
    ctx.globalAlpha = 0.5;

    for (let i = 1; i < xSteps; i += 1) {
        const x = (width / xSteps) * i;
        ctx.beginPath();
        ctx.moveTo(x, 0);
        ctx.lineTo(x, height);
        ctx.stroke();
    }

    for (let i = 1; i < ySteps; i += 1) {
        const y = (height / ySteps) * i;
        ctx.beginPath();
        ctx.moveTo(0, y);
        ctx.lineTo(width, y);
        ctx.stroke();
    }

    ctx.restore();
}
